export const STRING_SHORT_MAX_LENGTH = 50;
export const STRING_LONG_MAX_LENGTH = 255;
export const STRING_VERY_LONG_MAX_LENGTH = 4000;
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 50;
export const SUPPORTED_IMAGE_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];
export const MAX_FILE_SIZE = 2 * 1024 * 1024;
